import { render, staticRenderFns } from "./CalculateSalaryProcessResultForLuca.vue?vue&type=template&id=3da27cf0&"
import script from "./CalculateSalaryProcessResultForLuca.vue?vue&type=script&lang=js&"
export * from "./CalculateSalaryProcessResultForLuca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports